import axios from "../../plugins/axios";
import utils from "../../../utils/utils";

class Interface {
    //---------------------PLMi接口，工厂映射相关--------------------------//
    //INTF-00656：获取工厂映射表
    async getFactoryMapTableWithPLM() {
        let body = {};
        try {
            let res = await axios.post(`/myBasicDataApp/service.plm_interface.PlmInterfaceProvider/FindAll`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.infos = [];
            }
            return res;
        } catch (err) {
            console.log("get factory mapping table with PLM failed: INTF-00656", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00657：对新建的一条工厂映射记录进行保存
    addFactoryMapWithPLM(val) {
        let body = val;
        return axios.post(`/myBasicDataApp/service.plm_interface.PlmInterfaceProvider/CreateOne`, body);
    }

    //INTF-00658：更新一条工厂映射记录
    updateFactoryMapWithPLM(val) {
        let body = val;
        return axios.post(`/myBasicDataApp/service.plm_interface.PlmInterfaceProvider/UpdateDetails`, body);
    }

    //INTF-00659：删除选中的映射记录
    batchDeleteFactoryMapWithPLM(arr) {
        let body = { id_arr: arr };
        return axios.post(`/myBasicDataApp/service.plm_interface.PlmInterfaceProvider/Delete`, body);
    }

    //-----------------------PLM接口，单位映射相关---------------------------//
    //INTF-00674：获取单位映射表
    async getUomMapTableWithPLM() {
        let body = {};
        try {
            let res = await axios.post(`/myBasicDataApp/service.plm_unit.ScmPlmUnitMappingProvider/FindAllWithoutLimit`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.pum = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get uom mapping table with PLM failed: INTF-00674", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00675：对新建的一条单位映射记录进行保存
    addUomMapWithPLM(val) {
        let body = val;
        return axios.post(`/myBasicDataApp/service.plm_unit.ScmPlmUnitMappingProvider/CreateOne`, body);
    }

    //INTF-00676：更新一条单位映射记录
    updateUomMapWithPLM(val) {
        let body = val;
        return axios.post(`/myBasicDataApp/service.plm_unit.ScmPlmUnitMappingProvider/UpdateDetails`, body);
    }

    //INTF-00677：删除选中的映射记录
    batchDeleteUomMapWithPLM(arr) {
        let body = { id_arr: arr };
        return axios.post(`/myBasicDataApp/service.plm_unit.ScmPlmUnitMappingProvider/Delete`, body);
    }


}


export default Interface;